<template>
  <div class="container-fluid home-bg py-4">
    <div class="row">
      <div class="col-lg-12 col-md-12 mb-md-0 mb-4">
        <div class="card h-100">
          <div class="card-header pb-0">
            <div class="row">
              <div class="col-12">
                <h4 class="card-title">{{ window_title }}</h4>
                <p class="card-category">{{ description }}</p>
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div
                class="col-12 col-md-3 p-4"
                v-for="item in Platforms"
                :key="item.id"
              >
                <div
                  v-if="item.subscribe == 0 || item.subscribe == null || item.subscribe == undefined"
                  class="card h-100"
                  style="
                    background-color: #f4f5f6;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                  "
                >
                  <div class="card-head text-center">
                    <img
                      v-if="item.url_image"
                      :src="item.url_image"
                      alt="..."
                      class="img-fluid m-0"
                      style="
                        width: 100%;
                        aspect-ratio: 1/1;
                        margin: none;
                        object-position: center;
                        border-radius: 8% 8% 0 0;
                        object-fit: cover;
                      "
                    />
                    <img
                      v-else
                      src="../../core_assets/img/ccdlogolite.png"
                      alt="..."
                      class="img-fluid m-0"
                      style="
                        width: 100%;
                        aspect-ratio: 1/1;
                        margin: none;
                        object-position: center;
                        border-radius: 8% 8% 0 0;
                        object-fit: contain;
                      "
                    />
                  </div>

                  <div class="card-body d-flex flex-column">
                    <h6
                      class="platform-title"
                      :title="item.name"
                    >
                      {{ item.name }}
                    </h6>

                    <div class="mt-auto">
                      <h6
                        class="mb-2"
                        v-if="
                          item.autoapproved == 1
                        "
                      >
                        Gratis
                      </h6>
                      <button
                        type="button"
                        class="btn btn-sm bg-gradient-fvf float-right mb-0"
                        @click.prevent="goToPlataform(item.id)"
                      >
                        Ver detalle
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  v-if="item.subscribe == 1"
                  class="card h-100"
                  style="
                    background-color: #f4f5f6;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                  "
                >
                  <div class="card-head text-center">
                    <img
                      v-if="item.url_image"
                      :src="item.url_image"
                      alt="..."
                      class="img-fluid m-0"
                      style="
                        width: 100%;
                        aspect-ratio: 1/1;
                        margin: none;
                        object-position: center;
                        border-radius: 8% 8% 0 0;
                        object-fit: cover;
                      "
                    />
                    <img
                      v-else
                      src="../../core_assets/img/ccdlogolite.png"
                      alt="..."
                      class="img-fluid m-0"
                      style="
                        width: 100%;
                        aspect-ratio: 1/1;
                        margin: none;
                        object-position: center;
                        border-radius: 8% 8% 0 0;
                        object-fit: contain;
                      "
                    />
                  </div>
                  <div class="card-body d-flex flex-column">
                    <h6
                      class="platform-title mb-0"
                      :title="item.name"
                    >
                      {{ item.name }}
                    </h6>
                    <div class="mt-auto">
                      <h6
                        class="mb-0"
                        v-if="
                          item.autoapproved == 1
                        "
                      >
                        Gratis
                      </h6>
                      <p class="mb-2 mt-0">
                        Estado de postulación: <strong>Pendiente</strong>
                      </p>
                      <button
                        type="button"
                        class="btn btn-sm bg-gradient-fvf float-right mb-0"
                        @click.prevent="goToPlataform(item.id)"
                      >
                        Ver detalles
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  v-if="item.subscribe == 2"
                  class="card h-100"
                  style="
                    background-color: #f4f5f6;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                  "
                >
                  <div class="card-head text-center">
                    <img
                      v-if="item.url_image"
                      :src="item.url_image"
                      alt="..."
                      class="img-fluid m-0"
                      style="
                        width: 100%;
                        aspect-ratio: 1/1;
                        margin: none;
                        object-position: center;
                        border-radius: 8% 8% 0 0;
                        object-fit: cover;
                      "
                    />
                    <img
                      v-else
                      src="../../core_assets/img/ccdlogolite.png"
                      alt="..."
                      class="img-fluid m-0"
                      style="
                        width: 100%;
                        aspect-ratio: 1/1;
                        margin: none;
                        object-position: center;
                        border-radius: 8% 8% 0 0;
                        object-fit: contain;
                      "
                    />
                  </div>
                  <div class="card-body d-flex flex-column">
                    <h6
                      class="platform-title"
                      :title="item.name"
                    >
                      {{ item.name }}
                    </h6>
                    <div class="mt-auto">
                      <h6
                        class="mb-0"
                        v-if="
                          item.autoapproved == 1
                        "
                      >
                        Gratis
                      </h6>
                      <p class="mb-2">
                        Estado de postulación: <strong>Rechazado</strong>
                      </p>
                      <button
                        type="button"
                        class="btn btn-sm bg-gradient-fvf float-right mb-0"
                        @click.prevent="goToPlataform(item.id)"
                      >
                        Ver detalles
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  v-if="item.subscribe == 3"
                  class="card h-100"
                  style="
                    background-color: #f4f5f6;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                  "
                >
                  <div class="card-head text-center">
                    <img
                      v-if="item.url_image"
                      :src="item.url_image"
                      alt="..."
                      class="img-fluid m-0"
                      style="
                        width: 100%;
                        aspect-ratio: 1/1;
                        margin: none;
                        object-position: center;
                        border-radius: 8% 8% 0 0;
                        object-fit: cover;
                      "
                    />
                    <img
                      v-else
                      src="../../core_assets/img/CCD_LOGO_2.png"
                      alt="..."
                      class="img-fluid m-0"
                      style="
                        width: 100%;
                        aspect-ratio: 1/1;
                        margin: none;
                        object-position: center;
                        border-radius: 8% 8% 0 0;
                        object-fit: contain;
                      "
                    />
                  </div>
                  <div class="card-body d-flex flex-column">
                    <h6
                      class="platform-title"
                      :title="item.name"
                    >
                      {{ item.name }}
                    </h6>
                    <div class="mt-auto">
                      <h6
                        class="mb-0"
                        v-if="
                          item.autoapproved == 1
                        "
                      >
                        Gratis
                      </h6>
                     
                      <p class="mb-2">
                        Estado de postulación: <strong>Aprobado</strong>
                      </p>
                      <button
                        type="button"
                        class="btn btn-sm bg-gradient-fvf float-right mb-0"
                        @click.prevent="goToPlataform(item.id)"
                      >
                        Ver detalles
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import { mapState } from "vuex";
import { mapActions } from "vuex";
import moment from "moment";
import LTable from "src/components/Table_Home.vue";
import Card from "src/components/Cards/Card.vue";

export default {
  name: "Overview",
  components: {
    Card,
    LTable,
  },

  computed: {
    polar: function () {
      return "../../../public/logo_polar.png";
    },
  },
  data() {
    return {
      window_title: "Bienvenido a Campus CCD",
      description:
        "En este entorno podrás acceder a todas las capacitaciones impartidas por el Centro de Capacitación y Desarrollo de la Federación Venezolana de Fútbol, accede a cada curso y postúlate en el que sea de tu interés",
      id_role: Cookies.get("id_role"),
      Platforms: [],
    };
  },
  mounted() {
    console.log(this.id_role);
    // this.isAdmin(this.role);
    this.loadPlatform();
  },
  methods: {
    ...mapActions(["getData", "changeStatusData"]),

    changeStatus(data) {
      console.log("UPDATING");
      this.idTemp = data.id;
      this.ref_img = data.url_image;
      console.log(this.idTemp);
      this.getElement(this.idTemp);
      setTimeout(() => {
        $("#modalApproved" + this.idTemp).modal("toggle");
      }, 100); // tiempo en milisegundos

      this.modalActiveUpdate = true;
    },

    goTo(name) {
      this.$router.push(name);
    },

    goToPlataform(id) {
      this.$router.push({ path: "/platform/" + id });
    },

    goToCourse(url) {
      window.open(url, "_blank");
    },

    loadPlatform() {
      let form = {
        url: "user/platform/all",
        params: {
          active: 1,
          order_by: "id",
          order_value: "desc",
        },
      };
      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.Platforms = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    isAdmin(role) {
      console.log(role);
      if (this.role === 2) {
        Swal.fire({
          title: "Prohibido acceso",
          text: "Este usuario no puede acceder al panel administrativo",
          icon: "warning",
          customClass: {
            confirmButtonColor: "#B49B57",
            confirmButton: "btn bg-gradient-fvf",
          },
        });
        this.$router.push("/login");
      }
    },

    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    amountFormatted(amount) {
      if (!amount) return "";
      const value = Number(amount);
      if (isNaN(value)) return "";
      return value.toLocaleString("es-VE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    // Agrega los métodos que necesites aquí
  },
};
</script>

<style>
.addess_over td:nth-child(3) {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 120px;
  width: 120px;
}

.addess_over td:last-child {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 200px;
  width: 100%;
  padding-left: 100px;
  display: flex !important;
  /* Establecer el elemento como un contenedor flexible */
  flex-wrap: wrap;
  /* Permitir que los botones se ajusten a la celda */
}

.addess_over td:last-child .btn {
  flex: 1 0 auto;
  margin: 1px;
  /* Reducir la distancia entre botones */
}

.page-item.active .page-link {
  z-index: 1;
  color: #fff;
}

.circle_fvf {
  height: 35px;
  width: 35px;
  background-color: #643047; /* Cambia esto al color que desees */
  border-radius: 50%;
}

.circle_fvf_gold {
  height: 35px;
  width: 35px;
  background-color: #b49b57; /* Cambia esto al color que desees */
  border-radius: 50%;
}

.circle_black {
  height: 35px;
  width: 35px;
  background-color: black; /* Cambia esto al color que desees */
  border-radius: 50%;
}

.circle_red {
  height: 30px;
  width: 30px;
  background-color: #ce0d0d; /* Cambia esto al color que desees */
  border-radius: 50%;
}

.circle_blue {
  height: 30px;
  width: 30px;
  background-color: #003068; /* Cambia esto al color que desees */
  border-radius: 50%;
}

.circle_yellow {
  height: 30px;
  width: 30px;
  background-color: #ffc700; /* Cambia esto al color que desees */
  border-radius: 50%;
}

.circle_redwine {
  height: 20px;
  width: 20px;
  background-color: #541a32; /* Cambia esto al color que desees */
  border-radius: 50%;
}

.platform-title {
  color: #333;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.4;
  height: 2.8em;
  margin-bottom: 0.5rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}
</style>
<!-- <script src="../../core_assets/js/plugins/perfect-scrollbar.min.js"></script> -->
<!-- <script src="../../core_assets/js/plugins/smooth-scrollbar.min.js"></script>


 <script>
// var win = navigator.platform.indexOf("Win") > -1;
// if (win && document.querySelector("#sidenav-scrollbar")) {
//   var options = {
//     damping: "0.5",
//   };
//   Scrollbar.init(document.querySelector("#sidenav-scrollbar"), options);
// }
</script> -->
<!-- <script src="../../core_assets/js/soft-ui-dashboard.min.js?v=1.0.7"></script> -->
